import { Component, signal, computed, inject, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterOutlet, Router } from '@angular/router';
import { HeaderComponent } from './shared/components/ui/header/header';
import { SnackbarComponent } from './shared/components/ui/snackbar/snackbar.component';
import { AnaAssistantComponent } from './shared/components/ui/ana-assistant/ana-assistant';
import { ContactarUtentePanelComponent } from './pages/patients/mat-patient-detail/contactar-utente-panel/contactar-utente-panel';
import { AuthService } from './core/services/auth.service';
import { ContactarUtentePanelService } from './core/services/contactar-utente-panel.service';
import { CookieBannerComponent } from './shared/components/cookie-banner/cookie-banner';
import { ClarityConsentService } from './shared/services/clarity-consent.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, HeaderComponent, SnackbarComponent, AnaAssistantComponent, ContactarUtentePanelComponent, CookieBannerComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class App {
  protected readonly title = signal('EzfyWeb');

  /** Microsoft Clarity consent; its "Definições de cookies" footer shows only when Clarity is configured (production). */
  protected readonly cookieConsent = inject(ClarityConsentService);

  // Check if current route is an auth page
  readonly isAuthPage = signal(false);

  // Check if user is authenticated - computed after initialization
  readonly isAuthenticated = computed(() => this.authService.isAuthenticated());

  constructor(
    private router: Router,
    private authService: AuthService,
    private contactarPanel: ContactarUtentePanelService
  ) {}

  ngOnInit(): void {
    // Check if current route is an auth page or printable page
    this.router.events.subscribe(() => {
      const currentUrl = this.router.url;
      // Check for auth-related routes: /signup, /reset-password, root / (login), or any /auth/ routes
      // Also check for printable routes (should not show header)
      const isAuthRoute = 
        currentUrl === '/' || 
        currentUrl === '/signup' || 
        currentUrl.startsWith('/signup') ||
        currentUrl === '/reset-password' ||
        currentUrl.startsWith('/reset-password') ||
        currentUrl.includes('/auth/') ||
        currentUrl.includes('/printable');
      this.isAuthPage.set(isAuthRoute);
    });
  }

  onHeaderMenuItemClick(path: string): void {
    this.router.navigate([path]);
  }

  async onHeaderUserMenuAction(action: string): Promise<void> {
    switch (action) {
      case 'profile':
        this.router.navigate(['/profile']);
        break;
      case 'logout': {
        this.contactarPanel.close();
        // A group session ends at the portal, which navigates away from here itself; routing
        // home as well would show this app for the moment that takes. Asked before the
        // sign-out, because it clears the mark that answers it.
        const group = this.authService.isSsoSession();
        await this.authService.logout();
        if (!group) {
          this.router.navigate(['/']);
        }
        break;
      }
    }
  }

  onLayoutSidebarToggle(expanded: boolean): void {
    //console.log('Sidebar toggled:', expanded);
  }
}
